import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { navLabelFor } from './nav';

/** The suffix every title in this console carries, matching the auth and error screens. */
const SUFFIX = 'وحدة تحكّم شاهدني';

/**
 * Name the document after the surface being looked at.
 *
 * **Every working route shared one static title.** `index.html` ships «شاهدني ·
 * وحدة التحكّم» and only the sign-in, 404 and 500 screens ever replaced it, so
 * `/users`, `/plans`, `/subscriptions` and the rest were indistinguishable in a
 * tab strip, in a history list, and in a window switcher — on a console whose
 * whole working pattern is several surfaces open at once. Worse, navigating
 * client-side out of `/login` left that screen's title in place, so a signed-in
 * operator's tab read «سجّل الدخول».
 *
 * The label comes from the navigation table rather than a second per-route list:
 * the nav already names every destination, and the name the tab shows should be
 * the name the sidebar shows.
 *
 * **A path the table does not name is left alone**, deliberately. This shell is
 * mounted twice — once behind the guard, once for `/404` and `/500` — and those
 * two pages set their own titles, which say something this hook could not
 * derive. React runs a child's effect before its parent's, so an unconditional
 * fallback here would overwrite them a frame after they were set.
 */
export function useDocumentTitle(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    const label = navLabelFor(pathname);
    if (label) document.title = `${label} — ${SUFFIX}`;
  }, [pathname]);
}
